import * as React from "react"

/* EGDE-238: image/photo icon for uploaded-image chips (frame + sun + mountain),
   matching the picture glyph in the Figma upload design. Same 20px box and
   currentColor/1.5 stroke as Paperclip so it sits consistently in the chips. */
const ImageIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <rect
      x={3}
      y={3}
      width={18}
      height={18}
      rx={2}
      ry={2}
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <circle cx={8.5} cy={8.5} r={1.5} stroke="currentColor" strokeWidth={1.5} />
    <path
      d="m21 15-4.5-4.5L6 21"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default ImageIcon
